import React from 'react';
import { Flex } from 'antd';

import { ChatListContainer } from 'features/analytics/features/ChatList/containers/ChatListContainer';

import { MessagesContainer } from './containers/MessagesContainer';
import { useAppSelector } from '../../../../store';
import { MessagesChart } from './components/MessagesChart';
import { MessageTopicsChart } from './components/MessageTopicsChart';
import { MessagesMultiLineChart } from './components/MessagesMultiLineChart';
import { ActiveMembersChart } from '../AnalyticMembers/components/ActiveMembersChart';
import { selectAnalyticsFilters } from '../../store/analyticFiltersSlice';
import { getCurrentPageSlug } from '../AnalyticsFilters/utils/filters';
import { PAGE_TYPE } from '../../components/TabSwitcher/service/tabs.interface';

export const AnalyticMessages = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    return (
        <Flex gap={16} vertical>
            {getCurrentPageSlug(filters) === PAGE_TYPE.MANAGE ? (
                <>
                    <Flex gap={16} justify={'space-between'} wrap={'wrap'}>
                        <MessagesChart />
                        {filters.chat && <MessageTopicsChart />}
                    </Flex>
                    <Flex gap={16}>
                        <Flex flex={2}>
                            <MessagesMultiLineChart />
                        </Flex>

                        <Flex flex={1}>
                            <ActiveMembersChart />
                        </Flex>
                    </Flex>
                </>
            ) : (
                <Flex gap={16}>
                    <MessagesMultiLineChart />
                    <MessagesChart />
                </Flex>
            )}

            {filters.chat ? <MessagesContainer /> : <ChatListContainer />}
        </Flex>
    );
};
